/* ripple AIR singles carousel. The slides ride the rim of a big vertical wheel: the active
   one sits at the top apex and every step rotates the whole wheel by one segment, so
   neighbours swing outward AND downward and tilt with the rim. Positions come from the
   circular distance to the active index, so the ring wraps both ways. */
(function () {
  'use strict';
  function qsa(el, s) { return [].slice.call(el.querySelectorAll(s)); }

  function Ras(root) {
    this.root = root;
    this.slides = qsa(root, '[data-ras-slide]');
    this.bgs = qsa(root, '[data-ras-bg]');
    this.caps = qsa(root, '[data-ras-cap]');
    this.i = 0;
    if (this.slides.length) this.init();
  }

  Ras.prototype.raw = function (name) {
    return getComputedStyle(this.root).getPropertyValue(name).trim();
  };
  Ras.prototype.num = function (name, dflt) {
    var v = parseFloat(this.raw(name));
    return isFinite(v) ? v : dflt;
  };
  /* Custom properties come back as the AUTHORED token, not a resolved length, so a bare
     parseFloat turns "49vw" into 49px. Resolve the unit ourselves. */
  Ras.prototype.len = function (name, dflt) {
    var raw = this.raw(name), n = parseFloat(raw);
    var w = this.root.clientWidth || window.innerWidth || 1440;
    if (!isFinite(n)) return dflt;
    if (raw.indexOf('vw') > -1) return (window.innerWidth || w) * n / 100;
    if (raw.indexOf('%') > -1) return w * n / 100;
    if (raw.indexOf('px') > -1) return n;
    return w * n;                       /* unitless = fraction of the section width */
  };

  Ras.prototype.place = function () {
    var n = this.slides.length, self = this;
    var R = this.len('--ras-radius', 1500);
    var step = this.num('--ras-step', 15) * Math.PI / 180;
    var tilt = this.num('--ras-tilt', 1);
    var p1 = this.num('--ras-peek1', 0.38);
    var p2 = this.num('--ras-peek2', 0.33);
    var o1 = this.num('--ras-op1', 0.6);
    var o2 = this.num('--ras-op2', 0.4);
    this.slides.forEach(function (el, k) {
      var d = k - self.i;
      if (d > n / 2) d -= n;
      if (d < -n / 2) d += n;            /* wrap to the shortest way round */
      var a = Math.abs(d), th = d * step;
      var x = R * Math.sin(th);          /* apex of the wheel is the active slot */
      var y = R * (1 - Math.cos(th));
      var s = a === 0 ? 1 : (a === 1 ? p1 : p2);
      var f = parseFloat(el.getAttribute('data-ras-scale'));   /* per-product size trim */
      if (isFinite(f)) s *= f / 100;
      var op = a === 0 ? 1 : (a === 1 ? o1 : (a === 2 ? o2 : 0));
      var tf = 'translate3d(' + Math.round(x) + 'px,' + Math.round(y) + 'px,0)'
        + ' rotate(' + (th * tilt * 180 / Math.PI).toFixed(2) + 'deg) scale(' + s + ')';
      /* A slide that rolls over the back of the ring changes seat by more than one step.
         Animating that would drag it straight across the stage, so reseat it with the
         transition off and let it fade in where it lands. */
      var prev = el.__d, first = prev === undefined;
      var jump = first || Math.abs(d - prev) > 1;
      el.__d = d;
      if (jump) {
        el.style.transition = 'none';
        el.style.transform = tf;
        el.style.opacity = first ? op : 0;
        void el.offsetHeight;            /* flush, so the reseat is not animated */
        el.style.transition = '';
      } else {
        el.style.transform = tf;
      }
      el.style.opacity = op;
      el.style.zIndex = Math.max(1, 4 - a);
    });
    this.bgs.forEach(function (b, k) { b.classList.toggle('is-on', k === self.i); });
    this.caps.forEach(function (c, k) {
      c.classList.toggle('is-on', k === self.i);
      c.setAttribute('aria-hidden', k === self.i ? 'false' : 'true');
    });
  };

  Ras.prototype.go = function (i) {
    var n = this.slides.length;
    this.i = ((i % n) + n) % n;
    this.place();
  };

  Ras.prototype.add = function (btn) {
    var id = btn.getAttribute('data-ras-variant');
    if (!id || btn.disabled) return;
    var self = this, html = btn.innerHTML;
    var msg = btn.parentNode.querySelector('[data-ras-msg]');
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    this.say(msg, '');
    btn.disabled = true; btn.textContent = 'ADDING…';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      /* an edge or rate-limit error can answer with HTML - don't let that throw */
      return r.json().catch(function () { return {}; }).then(function (body) {
        return { ok: r.ok, body: body };
      });
    }).then(function (res) {
      if (res.ok) {
        btn.innerHTML = html; btn.disabled = false;
        openCart();
        return;
      }
      /* A refused add used to send shoppers to /cart, which this theme forwards to the home
         page. Stay put and say why. Shopify's description is a readable sentence ("The
         product 'X' is already sold out."); when it says sold out, the button says so too. */
      var why = res.body && res.body.description;
      if (why && /sold out/i.test(why)) {
        self.soldOut(btn);
      } else {
        btn.innerHTML = html; btn.disabled = false;
      }
      self.say(msg, why || self.root.getAttribute('data-ras-error'));
    }).catch(function () {
      btn.innerHTML = html; btn.disabled = false;
      self.say(msg, self.root.getAttribute('data-ras-error'));
    });
  };

  /* same look the Liquid renders for a flavour that was already sold out at page load */
  Ras.prototype.soldOut = function (btn) {
    btn.disabled = true;
    btn.classList.add('is-sold-out');
    btn.removeAttribute('data-ras-variant');
    var label = document.createElement('span');
    label.textContent = this.root.getAttribute('data-ras-sold-out') || 'Sold Out';
    btn.textContent = '';
    btn.appendChild(label);
  };

  Ras.prototype.say = function (el, text) {
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  };

  /* same ladder the Quit Kit build uses: let the theme's drawer handle it, then fall back */
  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    try {
      if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.show) {
        window.Rebuy.SmartCart.show(); return;
      }
    } catch (e) {}
    var link = document.querySelector('a.cart-link, [data-cart-drawer-toggle], .js-drawer-open-cart');
    if (link) { link.click(); return; }
    window.location.href = '/cart';
  }

  Ras.prototype.init = function () {
    var self = this, root = this.root;
    qsa(root, '[data-ras-prev]').forEach(function (b) {
      b.addEventListener('click', function () { self.go(self.i - 1); });
    });
    qsa(root, '[data-ras-next]').forEach(function (b) {
      b.addEventListener('click', function () { self.go(self.i + 1); });
    });
    qsa(root, '[data-ras-variant]').forEach(function (b) {
      b.addEventListener('click', function () { self.add(b); });
    });

    /* swipe */
    var x0 = null, y0 = null;
    var stage = root.querySelector('[data-ras-stage]') || root;
    stage.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.go(self.i + (dx < 0 ? 1 : -1));
    }, { passive: true });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') self.go(self.i + 1);
      else if (e.key === 'ArrowLeft') self.go(self.i - 1);
    });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t); t = setTimeout(function () { self.place(); }, 150);
    });
    window.addEventListener('load', function () { self.place(); });
    this.place();
  };

  function boot() { qsa(document, '[data-ras]').forEach(function (r) { if (!r.__ras) r.__ras = new Ras(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
